import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "button", "icon"]

  connect() {
    this.isOpen = false
  }

  toggle(event) {
    if (event) {
      event.preventDefault()
    }

    this.isOpen = !this.isOpen

    if (this.hasContentTarget) {
      if (this.isOpen) {
        this.contentTarget.classList.remove("hidden")
        // Animate in
        requestAnimationFrame(() => {
          this.contentTarget.style.opacity = "1"
          this.contentTarget.style.transform = "translateY(0)"
        })
      } else {
        this.contentTarget.style.opacity = "0"
        this.contentTarget.style.transform = "translateY(-10px)"
        setTimeout(() => {
          this.contentTarget.classList.add("hidden")
        }, 200)
      }
    }

    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("rotate-180")
    }

    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", this.isOpen)
    }
  }

  show() {
    this.isOpen = true
    if (this.hasContentTarget) {
      this.contentTarget.classList.remove("hidden")
    }
  }

  hide() {
    this.isOpen = false
    if (this.hasContentTarget) {
      this.contentTarget.classList.add("hidden")
    }
  }
}
